import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { thisBaseURL } from "../../utils/helper.js";
require("highcharts/modules/accessibility")(Highcharts);

function AnnualProductionQuantity({foodAnswers, foodName}){
	let defaultSlug = foodAnswers.answerKeyValues["food_slug"];
	let productionQty = foodAnswers.answerKeyValues['u_s_production_quantity'];
	let productionQtyYear = foodAnswers.answerKeyValues['u_s_production_quantity_year'];
	let productionQtySourceRef = foodAnswers.answerKeyValues['u_s_production_quantity_sources'];
	let productionQtyNotes = foodAnswers.answerKeyValues['u_s_production_quantity_notes'];
	let productionQtyUnits = foodAnswers.answerKeyValues['u_s_production_quantity_unit'] || 'Metric Tons';
	
	let array = [];
	let dataSeries = [];
	let xAxisCategories = [];
	if(productionQty){
		try {
			array =  JSON.parse(productionQty);
		} catch (err) {
			console.log("AnnualProductionQuantity :productionQty: " +err);
		}
		dataSeries = array.map(function (obj) {
			if(obj && obj["year"] && obj["weight_specify_units_"]){
				return [parseInt(obj["year"]),parseFloat(obj["weight_specify_units_"].replace(/,/g, ''))];
			}
		});
		xAxisCategories = array.map(function (obj) {
			if(obj && obj["year"]){
				return [parseInt(obj["year"])];
			}
		});
	}
	let titleText = '';
	if(dataSeries && dataSeries.length > 0 && dataSeries[0]){
		titleText = 'Annual Quantity of  '+foodName+' Produced in the United States ('+dataSeries[0][0]+' - '+dataSeries[dataSeries.length - 1][0]+")";
	}
	
	return(
			<div>
				{(dataSeries && dataSeries.length > 0 && dataSeries[0]) ? <><h2 style={{textAlign: "center"}}>
					{titleText}
					{ productionQtySourceRef && productionQtySourceRef > 0 ?
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+productionQtySourceRef}>{productionQtySourceRef}</a></small>:
					""	
					}
				</h2>
				<HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: "60vw" } }}
				options={{
				 	title: {
						text: ''
					},
					credits: {
						enabled: false
					},
					lang: {
						thousandsSep: ','
					},
					yAxis: {
						title: {
							text: productionQtyUnits
						},
						plotLines: [{
							value: 0,
							width: 1,
							color: '#808080'
						}]
					},
			        xAxis: {
					  categories: xAxisCategories,
			          title:  {
						text: 'Year'
				  		}
			        },
					legend: {
						enabled: false,
						layout: 'vertical',
						align: 'right',
						verticalAlign: 'middle',
						borderWidth: 0
					},
					series: [{
						name: productionQtyUnits,
						data: dataSeries
						}]
				}}
				/>
				{productionQtyNotes  ? 
				<p className="notes-info" style={{marginTop: "auto"}}>
				<em>{productionQtyNotes}</em>
				</p>
				:""}
				</>:""}
			</div>
		)
}
export default AnnualProductionQuantity;